import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import React from "react";
import { createPortal } from "react-dom";
import { AdjustmentForm } from "src/components/molecules/AdjustmentForm";
import { Icon, ModalContent, ModalHeader, ModalWindow, ModalWrapper } from "./styles";
import { AdjustmentFormModalProps } from "./types";

const AdjustmentFormModal = ({
  defaultValues,
  reasons,
  closeModal: closeModel,
  onSubmit,
}: AdjustmentFormModalProps) => {
  if (typeof document === "undefined") {
    return null;
  }

  return createPortal(
    <ModalWrapper>
      <ModalWindow style={{ maxWidth: "474px" }}>
        <ModalHeader>
          <div>
            <h3>Adjustment</h3>
            <Icon onClick={closeModel} icon={faTimes as IconProp} />
          </div>
        </ModalHeader>
        <ModalContent>
          <AdjustmentForm onSubmit={onSubmit} onCancel={closeModel} reasons={reasons} defaultValues={defaultValues} />
        </ModalContent>
      </ModalWindow>
    </ModalWrapper>,
    document.body,
  );
};
export default AdjustmentFormModal;
